<template>
  <div class="row justify-content-center add-btn-wrapper mb-4">
    <span
      class="btn btn-primary col-8 col-md-4 btn-add-subitem mr-md-2"
      @click="addItemAtStart()"
      >{{ labelStart }}</span
    >
    <span
      class="btn btn-primary col-8 col-md-4 btn-add-subitem"
      @click="addItemAtEnd()"
      >{{ labelEnd }}</span
    >
  </div>
</template>
<script>
import helpers from "../../mixins/helpers";
export default {
  name: "custom-add-insert-buttons",
  mixins: [helpers],
  data: function () {
    return {
      id: null,
    };
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    template: {
      type: Object,
      required: true,
    },
    labelAddAtStart: {
      type: String,
      required: false,
    },
    labelAddAtEnd: {
      type: String,
      required: false,
    },
  },
  model: {
    prop: "list",
    event: "list:change",
  },
  computed: {
    listLocal: {
      get() {
        return this.list;
      },
      set(value) {
        this.$emit("list:change", value);
      },
    },
    labelStart() {
      return this.labelAddAtStart || "Insérer au début";
    },
    labelEnd() {
      return this.labelAddAtEnd || "Ajouter à la fin";
    },
  },
  methods: {
    clone(item) {
      return JSON.parse(JSON.stringify(item));
    },
    addItemAtEnd() {
      var item = this.clone(this.template);
      this.addListKeyToItem(item);
      this.listLocal.push(item);
      this.$isModified = true;
    },
    addItemAtStart() {
      var item = this.clone(this.template);
      this.addListKeyToItem(item);
      this.listLocal.unshift(item);
      this.$isModified = true;
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// components/Custom/add-insert-buttons.vue